/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { CalculatedProgram } from '../model/calculatedProgram';
import { ErrorInfo } from '../model/errorInfo';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class LoansAPIService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public calculateObservable: Array<CalculatedProgram> | undefined = undefined;

    /**
     * 
     * 
     * @param loanAmount 
* @param stateCode 
* @param tenantId 
* @param businessUnitId 
* @param allPlans 
     */
    @action
    public calculate(loanAmount: number, stateCode: string, tenantId: string, businessUnitId: string, allPlans: boolean, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<CalculatedProgram>> {
        if (loanAmount === null || loanAmount === undefined) {
            throw new Error('Required parameter loanAmount was null or undefined when calling calculate.');
        }
        if (stateCode === null || stateCode === undefined) {
            throw new Error('Required parameter stateCode was null or undefined when calling calculate.');
        }
        if (tenantId === null || tenantId === undefined) {
            throw new Error('Required parameter tenantId was null or undefined when calling calculate.');
        }
        if (businessUnitId === null || businessUnitId === undefined) {
            throw new Error('Required parameter businessUnitId was null or undefined when calling calculate.');
        }
        if (allPlans === null || allPlans === undefined) {
            throw new Error('Required parameter allPlans was null or undefined when calling calculate.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (loanAmount !== undefined) {
            queryParameters['loanAmount'] = loanAmount;
        }
        if (stateCode !== undefined) {
            queryParameters['stateCode'] = stateCode;
        }
        if (tenantId !== undefined) {
            queryParameters['tenantId'] = tenantId;
        }
        if (businessUnitId !== undefined) {
            queryParameters['businessUnitId'] = businessUnitId;
        }
        if (allPlans !== undefined) {
            queryParameters['allPlans'] = allPlans;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<CalculatedProgram>>(
            `${this.basePath}/api/financing-bridge/loans/calculations`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.calculateObservable = response.data);
            }
            return response;
        });
    }

}
